<template>

  <div class="group" :ref="refs['LabelGroup']">

    <div class="group-header" :id="`LabelTitle`">
      <div class="group-title">Product label</div>
    </div>

    <Text-Input
    key="label"
    field-label="label"
    field-name="label"
    :init-value=builder.currentItem.label
    :init-touched="false"
    placeholder="Leave blank to use default label ie. 'Customers's kitchen'"
    @update-value="updateProp"
    ></Text-Input>

  </div>

  <div class="group l_sub-group" :ref="refs[builder.description.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.description.fieldName}Title`">
      <div class="group-title">Product description</div>
    </div>

    <Text-Area
    :key=builder.description.fieldName
    :field-label=builder.description.fieldName
    :field-name=builder.description.fieldName
    :init-value=initialValue
    :init-touched="false"
    scope="specs"
    @update-value="updateValue"
    ></Text-Area>

  </div>

  <div class="group l_sub-group" :ref="refs['CostGroup']">

    <div class="group-header" :id="`CostTitle`">
      <div class="group-title">Product cost (ex GST)</div>
    </div>

    <Text-Input
    key="cost"
    field-label="cost"
    field-name="cost"
    field-type="number"
    :init-value="builder.currentItem.specs['cost']"
    :min="0"
    :max="9999999999999"
    :required="true"
    :init-touched="false"
    scope="specs"
    @update-value="updateValue"
    ></Text-Input>

  </div>

  <div class="group l_sub-group" :ref="refs['DeliveryCostGroup']" v-if="builder.isCp && builder.currentItem.productId == 9">

    <div class="group-header" :id="`DeliveryCostTitle`">
      <div class="group-title">Delivery cost (ex GST)</div>
    </div>

    <Text-Input
    key="deliveryCost"
    field-label="deliveryCost"
    field-name="deliveryCost"
    field-type="number"
    :init-value="builder.currentItem.specs['deliveryCost']"
    :min="0"
    :max="9999999999999"
    :required="true"
    :init-touched="false"
    scope="specs"
    @update-value="updateValue"
    ></Text-Input>

  </div>

</template>

<script setup>

import { computed, ref, onMounted } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

function select(prop, opt) {
  builder.setCurrentItemSpec(prop, opt['id']);
}

function updateValue(prop, val) {
  builder.setCurrentItemSpec(prop, val);
}

function updateProp(prop, val) {
  builder.setCurrentItemProp(prop, val);
}

function updateQuoteValue(prop, val) {
  builder.quote[prop] = val;
}

const initialValue = computed(() => {
  if (!_.isUndefined(builder.currentItem) && !_.isUndefined(builder.currentItem.specs) && !_.isUndefined(builder.currentItem.specs[builder.description.fieldName])) {
    return builder.currentItem.specs[builder.description.fieldName];
  }
  return null;
})

// init refs
let refHandles = [
  builder.description.fieldName + 'Group',
  'CostGroup',
  'DeliveryCostGroup'
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>
